var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useEffect, useRef } from "react";
import { loginRequest } from "./msalConfig";
const MicrosoftLogin = () => {
    const { instance, inProgress } = useMsal();
    const loginTriggeredRef = useRef(false);
    const handleLoginRedirect = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // instance.initialize() already awaited in index.tsx before this
            // component (or anything else using the msal instance) can mount.
            const redirectResult = yield instance.handleRedirectPromise();
            if (redirectResult || instance.getAllAccounts().length > 0) {
                return;
            }
            if (inProgress !== InteractionStatus.None || loginTriggeredRef.current) {
                return;
            }
            loginTriggeredRef.current = true;
            yield instance.loginRedirect(loginRequest);
        }
        catch (err) {
            console.error(err);
        }
    });
    useEffect(() => {
        handleLoginRedirect();
    }, [instance, inProgress]);
    return (_jsx(_Fragment, {}));
};
export default MicrosoftLogin;
